// Layout Types

import ProviderLayout from '../layout/ProviderLayout';
import MarketingSubs from '../provider/marketingSubs/MarketingSubs';

// Route Views

const marketingSubsRoutes = [
  {
    path: '/marketingSubs',
    exact: true,
    layout: ProviderLayout,
    component: <MarketingSubs />
  }
];

export default marketingSubsRoutes;
